(function () {
  const GRID_SELECTOR = '#product-grid';
  const GRID_CONTAINER_SELECTOR = '#ProductGridContainer';
  const SORT_SELECT_ID = 'SortBy';

  // Judge.me yüklenmesi için: 0 yorumlu ürünler yüzünden sonsuza kadar beklemeyelim
  const READY_RATIO = 0.6; // %60 dolunca uygula
  const MAX_WAIT_MS = 6000;

  let pending = null;
  let pauseUntil = 0; // infinite scroll ardışık tetiklerse kısa süreli duraklatma

  function now() {
    return Date.now();
  }

  function getUrlSortBy() {
    try {
      return new URL(window.location.href).searchParams.get('sort_by') || '';
    } catch (e) {
      return '';
    }
  }

  function setUrlSortBy(value) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function isMostReviewedSelected() {
    const url = getUrlSortBy();
    if (url === 'most-reviewed') return true;
    const select = document.getElementById(SORT_SELECT_ID);
    return !!select && select.value === 'most-reviewed';
  }

  // ✅ Dropdown’da seçili yazıyı güncelle (senin çalışan fonksiyonun)
  function syncCustomSelectUI(value) {
    const select = document.getElementById(SORT_SELECT_ID);
    if (!select) return;

    const root = select.closest('custom-select') || select.closest('.custom-select') || document;

    const optionButtons = Array.from(root.querySelectorAll('button[data-value]'));
    optionButtons.forEach((btn) => {
      const v = btn.getAttribute('data-value');
      if (!v) return;
      btn.setAttribute('aria-selected', v === value ? 'true' : 'false');
    });

    const selectedBtn = root.querySelector(`button[data-value="${CSS.escape(value)}"]`);
    const labelText = selectedBtn ? (selectedBtn.textContent || '').trim() : '';
    if (!labelText) return;

    const trigger =
      root.querySelector('.custom-select__button') ||
      root.querySelector('.custom-select__btn') ||
      root.querySelector('.custom-select__toggle') ||
      root.querySelector('button[aria-haspopup="listbox"]') ||
      root.querySelector('summary');

    if (!trigger) return;

    const textTarget =
      trigger.querySelector('.custom-select__text') ||
      trigger.querySelector('.js-btn-text') ||
      trigger.querySelector('span') ||
      trigger;

    // SVG'yi bozmadan sadece yazıyı güncelle
const svg = trigger.querySelector('svg');

// 1) Eğer daha önce oluşturduğumuz label span yoksa oluştur
let textSpan = trigger.querySelector('.custom-select__label');
if (!textSpan) {
  textSpan = document.createElement('span');
  textSpan.className = 'custom-select__label';

  if (svg) {
    trigger.insertBefore(textSpan, svg); // span, svg'nin solunda kalsın
  } else {
    trigger.appendChild(textSpan);
  }
}

// 2) Butonun içindeki "düz yazı" (text node) varsa temizle
// (text node = <span> olmadan direkt yazılan "Yeni gelenler" gibi metin)
Array.from(trigger.childNodes).forEach((node) => {
  if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length) {
    node.textContent = '';
  }
});

// 3) Bizim span dışındaki metin span'leri varsa (tema ekliyorsa) onları da boşalt
// (İstersen bunu kapatabiliriz ama genelde sorunu kökten çözer)
trigger.querySelectorAll('span:not(.custom-select__label)').forEach((sp) => {
  // Eğer bu span svg'nin içinde değilse ve gerçek label gibi kullanılıyorsa temizle
  if (!sp.closest('svg')) sp.textContent = '';
});

// 4) Sadece bizim span'i güncelle
textSpan.textContent = labelText;

  }

  function getReviewCountFromCard(cardEl) {
    const widget = cardEl.querySelector('.jdgm-widget.jdgm-preview-badge');
    if (!widget) return 0;

    const badge = widget.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
    if (badge) {
      const n = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      return Number.isFinite(n) ? n : 0;
    }

    const textEl = widget.querySelector('.jdgm-prev-badge__text');
    if (textEl) {
      const m = textEl.textContent.match(/\d+/);
      if (m) return parseInt(m[0], 10);
    }
    return 0;
  }

  function judgeMeFillStats() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return { total: 0, filled: 0, ratio: 0 };

    const total = grid.querySelectorAll('.jdgm-widget.jdgm-preview-badge').length;
    const filled = grid.querySelectorAll('.jdgm-prev-badge, .jdgm-prev-badge__text').length;
    const ratio = total > 0 ? filled / total : 0;

    return { total, filled, ratio };
  }

  // ✅ DOM taşımıyoruz: sadece CSS order
  function applyOrderMostReviewed() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const children = Array.from(grid.children);
    if (children.length < 2) return;

    const sortable = [];
    children.forEach((el) => {
      if (el.classList && el.classList.contains('js-card-text')) return;
      sortable.push({ el, reviews: getReviewCountFromCard(el) });
    });

    sortable.sort((a, b) => b.reviews - a.reviews);

    sortable.forEach((item, index) => {
      item.el.style.order = String(index);
    });

    // sabit metin vb. varsa sona
    children.forEach((el) => {
      if (el.classList && el.classList.contains('js-card-text')) {
        el.style.order = '99999';
      }
    });
  }

  function resetOrder() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;
    Array.from(grid.children).forEach((el) => (el.style.order = ''));
  }

  function waitThenApplyOrder(maxMs = MAX_WAIT_MS) {
    if (!isMostReviewedSelected()) return;
    const start = now();

    const tick = () => {
      if (!isMostReviewedSelected()) return;

      const { total, ratio } = judgeMeFillStats();
      if (total === 0) {
        // yıldız hiç yoksa direkt uygula (order etkisiz ama sorun değil)
        applyOrderMostReviewed();
        return;
      }

      if (ratio >= READY_RATIO) {
        applyOrderMostReviewed();
        return;
      }

      if (now() - start > maxMs) {
        applyOrderMostReviewed();
        return;
      }

      requestAnimationFrame(tick);
    };

    tick();
  }

  function scheduleApply() {
    if (!isMostReviewedSelected()) return;
    if (pending) return;

    pending = setTimeout(() => {
      pending = null;
      waitThenApplyOrder();
      // 2. kez (geciken widgetlar için)
      setTimeout(() => isMostReviewedSelected() && applyOrderMostReviewed(), 900);
    }, 120);
  }

  // ✅ Tema sort handler’ını SADECE most-reviewed’de engelle
  function interceptOnlyMostReviewed(e) {
    if (!e) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    // URL + select + UI senkron
    sessionStorage.setItem('custom_sort_by', 'most-reviewed');


    const select = document.getElementById(SORT_SELECT_ID);
    if (select) select.value = 'most-reviewed';

    syncCustomSelectUI('most-reviewed');
    scheduleApply();
      // En garanti: sayfada boş bir yere tıkla gibi davran
  document.body.click();

  }

  // 1) Native select change
  document.addEventListener(
    'change',
    function (e) {
      const el = e.target;
      if (!el || el.id !== SORT_SELECT_ID) return;

      if (el.value === 'most-reviewed') {
        interceptOnlyMostReviewed(e);
      } else {
        // tema normal sıralasın
        resetOrder();
      }
    },
    true
  );

  // 2) Custom select button click
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target && e.target.closest ? e.target.closest('button[data-value="most-reviewed"]') : null;
      if (!btn) return;

      interceptOnlyMostReviewed(e);
    },
    true
  );

  // 3) Infinite scroll: grid'e yeni kart gelince order'ı tekrar bas
  function observeInfinite() {
    const container = document.querySelector(GRID_CONTAINER_SELECTOR);
    if (!container) return;

    const observer = new MutationObserver((mutations) => {
      if (!isMostReviewedSelected()) return;
      if (now() < pauseUntil) return;

      let changed = false;

      for (const m of mutations) {
        if (m.type !== 'childList') continue;
        const nodes = [...(m.addedNodes || []), ...(m.removedNodes || [])];

        // Sadece product-card / grid değişimlerinde
        if (
          nodes.some(
            (n) =>
              n.nodeType === 1 &&
              (n.matches?.('product-card') ||
                n.querySelector?.('product-card') ||
                n.matches?.(GRID_SELECTOR) ||
                n.querySelector?.(GRID_SELECTOR))
          )
        ) {
          changed = true;
          break;
        }
      }

      if (!changed) return;

      // ardışık tetiklenirse 250ms kilitle
      pauseUntil = now() + 250;
      syncCustomSelectUI('most-reviewed');
      scheduleApply();
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeInfinite();

    // sayfa URL'sinde most-reviewed varsa otomatik uygula
    if (getUrlSortBy() === 'most-reviewed') {
      const select = document.getElementById(SORT_SELECT_ID);
      if (select) select.value = 'most-reviewed';
      syncCustomSelectUI('most-reviewed');
      scheduleApply();
    }
  });
})();
